import { publicPost, saveTokens, type Tokens } from "../api.ts";
import { append, errorText, h } from "../ui.ts";

/** Email-code sign-in. The app's "Team dashboard" button signs in without this. */
export function renderSignIn(root: HTMLElement, onDone: () => void, message = "") {
  const email = h("input", { type: "email", required: true, autocomplete: "email", "aria-label": "Work email", placeholder: "name@company.com" }) as HTMLInputElement;
  const code = h("input", { type: "text", inputmode: "numeric", pattern: "\\d{6}", maxlength: 6, required: true, autocomplete: "one-time-code", "aria-label": "6-digit code" }) as HTMLInputElement;
  const error = h("p", { class: "late", role: "alert" }, message);
  const send = h("button", { type: "submit", class: "primary" }, "Email me a code") as HTMLButtonElement;
  const verify = h("button", { type: "submit", class: "primary" }, "Sign in") as HTMLButtonElement;
  const back = h("button", { type: "button" }, "Use a different email") as HTMLButtonElement;

  const askEmail = h("form", { class: "stack" }, h("label", { class: "field" }, "Work email", email), h("div", { class: "actions" }, send));
  const askCode = h("form", { class: "stack", hidden: true }, h("label", { class: "field" }, "The 6-digit code we emailed you", code), h("div", { class: "actions" }, verify, back));

  askEmail.addEventListener("submit", async (e) => {
    e.preventDefault();
    error.textContent = "";
    send.disabled = true;
    try {
      await publicPost("/v1/auth/email/start", { email: email.value.trim() });
      askEmail.hidden = true;
      askCode.hidden = false;
      code.focus();
    } catch (err) {
      error.textContent = errorText(err);
    } finally {
      send.disabled = false;
    }
  });
  askCode.addEventListener("submit", async (e) => {
    e.preventDefault();
    error.textContent = "";
    verify.disabled = true;
    try {
      saveTokens(await publicPost<Tokens>("/v1/auth/email/verify", { email: email.value.trim(), code: code.value.trim() }));
      onDone();
    } catch (err) {
      error.textContent = errorText(err);
    } finally {
      verify.disabled = false;
    }
  });
  back.addEventListener("click", () => {
    askCode.hidden = true;
    askEmail.hidden = false;
    email.focus();
  });

  append(
    root,
    h(
      "section",
      { class: "signin" },
      h("h1", null, "Kai for Teams"),
      h("p", { class: "muted" }, "Sign in to see your company's training: who is on which track, how far they are, and who needs a nudge."),
      askEmail,
      askCode,
      error,
    ),
  );
}
